module.exports = __webpack_public_path__ + "static/media/icon.233c4f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/seo/icon.png
// module id = 190
// module chunks = 0